// extracted by css-extract-rspack-plugin
export default {"cls1":"RelatedWorksCard-cls1_0cU","cls2":"RelatedWorksCard-cls2__N8 RelatedWorksCard-cls1_0cU"};